module.exports = __webpack_public_path__ + "assets/images/mobileNavigation-80b6ffd09c790c07403dd357e9e40de6.png";